<tvcore-ivv-title title="Ons aanbod"></tvcore-ivv-title>

<a [routerLink]="['/']" class="back-btn u-text--medium">
	<tvcore-icon name="arrow"></tvcore-icon>
	{{ 'DETAIL.BACK_BUTTON' | translate }}
</a>

<h1 class="u-title u-m-top--md">{{ 'KAMPAS.TITLE' | translate }}</h1>

<div class="flex-row flex-column--sm flex--space u-m-top--xxs">
	<div class="flex-row flex-column--sm">
		<div class="tag">
			{{ 'KAMPAS.LABEL' | translate }}
		</div>
	</div>
</div>

<div [class]="'c-images u-m-top--md u-m-bottom--md c-images--' + (IMAGES.length + 1)">
	@for (img of IMAGES; track img.url) {
		<div (click)="indexImageCarousel.set($index)" [style.background-image]="'url(' + img.url + ')'">
			@if ($index === 4) {
				<p class="c-images__see-more c-images__see-more--lg">
					<tvcore-icon name="images"></tvcore-icon>
					{{ 'DETAIL.MORE_IMAGES' | translate: { amount: IMAGES.length + 1 } }}
				</p>
			}
		</div>

		<p class="c-images__see-more c-images__see-more--sm">
			<tvcore-icon name="images"></tvcore-icon>
			<br />
			{{ 'DETAIL.MORE_IMAGES' | translate: { amount: IMAGES.length + 1 } }}
		</p>
	}
</div>

@if (indexImageCarousel() !== null) {
	<ivva-image-carousel [(index)]="indexImageCarousel" [images]="IMAGES"></ivva-image-carousel>
}

<div class="c-intro">
	<div class="flex--1">
		<p class="u-text--medium">Wil je met je organisatie op groepsvakantie in een hostel of jeugdverblijf?</p>
		<p>
			Goed idee! Deze verblijven boek je aan sociaal tarief op <a href="https://kampas.be">kampas.be</a>. Kampas bundelt alle Vlaamse jeugdverblijven en hostels op één handig,
			aantrekkelijk platform. Honderden verblijven werken er mee aan Iedereen Verdient Vakantie. Je herkent ze aan onze vlinder!
		</p>
		<p>Wacht dus niet langer en ga op ontdekking in dit mooie, betaalbare aanbod!</p>
		<p>Je kan ze al tot 2029 boeken.</p>

		<br />

		<p class="u-text--medium">Ook voor volwassenen</p>
		<p>Laat je niet afschrikken door de naam: jeugdverblijven. Ook volwassenen zijn er meer dan welkom.</p>

		<br />

		<p class="u-text--medium">Hoe boek je je groepsvakantie op Kampas?</p>
		<p>Ga naar kampas.be en filter op ‘partner Iedereen Verdient Vakantie’. Maak je keuze en boek tegen sociaal tarief.</p>
		<p>(1) Een deel van de verblijven waar je zelf kan koken kan je direct boeken. Hoe? Registreer je als boeker of log in, als je organisatie al op Kampas gekend bent.</p>
		<p>
			(2) Alle andere verblijven contacteer je met het handige formulier. Vink daarop aan dat je organisatie partner is van het netwerk Iedereen Verdient Vakantie, en dat je
			vakantie voldoet aan onze voorwaarden. Op die manier weet de aanbieder dat je recht hebt op het sociale tarief!
		</p>
	</div>

	<div class="c-price-box">
		<a
			class="c-btn c-btn--blue c-btn--unset c-btn--with-icon"
			href="https://www.kampas.be/nl/zoeken?accommodation_search%5Bname%5D=&accommodation_search%5Btype%5D=&accommodation_search%5Blocation%5D=&accommodation_search%5Bperiod%5D=&accommodation_search%5Bcapacity%5D=&accommodation_search%5B_token%5D=5215bd69cf07033238806354ab.OfBE_srCzAQVohX0SKV5i2_o0RMFHt_vZqL24TwFGtk.DZo1tfqjgjVzlGfAHOFByDih4kJkZJ2rE-CErlNEWJF7uxSSmp2pXl3vJQ&page=1&page_limit=25&page_button_limit=5&year=2024&page=1&page_limit=25&page_button_limit=5&year=2024&member_of_i_v_v%5B%5D=true"
			target="_blank"
		>
			Boek aan sociaal tarief op Kampas
			<tvcore-icon name="external-link"></tvcore-icon>
		</a>
	</div>
</div>
